import { onReady } from './utils.js';

onReady( function() {
	const el = document.querySelector( '.c-article-content + .c-share-widget' );
	if ( ! el ) {
		return;
	}

	const observer = new IntersectionObserver(
		function( [ e ] ) {
			if ( e.intersectionRatio >= 1 ) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'article_interaction',
					interaction_type: 'content_consumed',
				} );
				observer.unobserve( el );
			}
		},
		{
			threshold: [ 1 ],
		},
	);

	observer.observe( el );
} );

onReady( function() {
	const article_links = document.querySelectorAll( '.c-article-content a[href]' );
	if ( article_links.length === 0 ) {
		return;
	}

	article_links.forEach( function( link ) {
		const url = new URL( link.href );

		if ( url.hostname === document.location.hostname ) {
			link.addEventListener( 'click', function() {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'article_interaction',
					interaction_type: 'related_article',
					interaction_option: link.href,
				} );
			} );
		} else {
			link.addEventListener( 'click', function() {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'article_interaction',
					interaction_type: 'link_click',
					interaction_option: link.href,
				} );
			} );
		}
	} );
} );

onReady( function() {
	const more_links = document.querySelectorAll( '.js-more-news a[href]' );
	if ( more_links.length === 0 ) {
		return;
	}

	more_links.forEach( function( link ) {
		link.addEventListener( 'click', function() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'article_interaction',
				interaction_type: 'related_article',
				interaction_option: link.href,
			} );
		} );
	} );
} );

onReady( function() {
	const share_links = document.querySelectorAll( '.c-share-widget a, .c-share-widget button' );
	if ( share_links.length === 0 ) {
		return;
	}

	share_links.forEach( function( link ) {
		const social = link.dataset.social;

		link.addEventListener( 'click', function() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'article_interaction',
				interaction_type: 'share',
				interaction_option: social,
			} );
		} );
	} );
} );

onReady( function() {
	const social_links = document.querySelectorAll( '.c-socials__item' );
	if ( social_links.length === 0 ) {
		return;
	}

	social_links.forEach( function( link ) {
		const social = link.dataset.social;

		link.addEventListener( 'click', function() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'article_interaction',
				interaction_type: 'social',
				interaction_option: social,
			} );
		} );
	} );
} );

onReady( function() {
	const gallery = document.querySelector( '.glide' );
	if ( ! gallery ) {
		return;
	}

	gallery.addEventListener( 'click', function() {
		const img = this.querySelector( '.glide__slide--active img' );

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			event: 'article_interaction',
			interaction_type: 'gallery',
			media_url: img.src,
		} );
	} );
} );

onReady( function() {
	const el = document.querySelector( '.c-article-content' );
	if ( ! el ) {
		return;
	}

	el.addEventListener( 'copy', function() {
		const selection = document.getSelection();

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			event: 'article_interaction',
			interaction_type: 'text_copy',
			interaction_option: selection.toString() ?? '',
		} );
	} );
} );
